module.exports = __webpack_public_path__ + "img/03-4.02c44ea0.png";